/**
 * MemberButton: 참여자 목록 패널 토글 버튼.
 *
 * v1 원본: RenewalComponents/Buttons/MemberButton/MemberButtonPresenter.js
 * v1 CSS: .rtc_new3 .newHeader_btnItem > .newHeader_btn
 */
import React, { useMemo } from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { isRecordingBot } from '@/utils/recordingBot';

const MemberButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const participants = useAppSelector((s) => s.participants);
  const ui = useAppSelector((s) => s.ui);
  const count = useMemo(() => {
    const visibleRemote = participants.participantIds.filter((id) => {
      const p = participants.participants[id];
      if (!p) return false;
      if (p.isHidden || p.isWhiteboard) return false;
      if (p.properties?.features_jigasi) return false;
      if (isRecordingBot(p)) return false;
      return true;
    });
    return visibleRemote.length + 1; // +1 for local
  }, [participants.participantIds, participants.participants]);

  const isActive = ui.openSideBar && ui.sidebarContent === 'participants';

  const handleClick = () => {
    if (isActive) {
      dispatch(uiActions.setOpenSideBar(false));
    } else {
      dispatch(uiActions.setSidebarContent('participants'));
    }
  };

  return (
    <div className="newHeader_btnItem" onClick={handleClick}>
      <button type="button" className="newHeader_btn">
        <span className="newHeader_btnIcon icoMember" />
        <p className="newHeader_btnText">
          참석자
        </p>
        <span className="newHeader_btnBadge">
          {count > 99 ? '99+' : count}
        </span>
      </button>
    </div>
  );
};

export default MemberButton;
